import { vec3 } from 'gl-matrix';
var tmpVecA = vec3.create();

var BoundingSphere =
/** @class */
function () {
  function BoundingSphere(center, radius) {
    this.center = center || vec3.create();
    this.radius = radius || 0.5;
  }

  BoundingSphere.prototype.containsPoint = function (point) {
    vec3.sub(tmpVecA, point, this.center);
    return vec3.length(tmpVecA) < this.radius * this.radius;
  };

  BoundingSphere.prototype.intersects = function (sphere) {
    vec3.sub(tmpVecA, sphere.center, this.center);
    var totalRadius = sphere.radius + this.radius;

    if (vec3.length(tmpVecA) <= totalRadius * totalRadius) {
      return true;
    }

    return false;
  };

  return BoundingSphere;
}();

export { BoundingSphere };